module.exports = __webpack_public_path__ + "static/media/mri-benefits.09a19cb2.jpg";